// src/util/request.js

import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'

// 判断当前环境
const isProduction = process.env.NODE_ENV === 'production'
const baseUrl = isProduction ? '/api' : 'http://localhost:8000/'

// 创建 axios 实例
const httpService = axios.create({
  baseURL: baseUrl,
  timeout: 60000
})

// 请求拦截器：自动添加 Bearer Token
httpService.interceptors.request.use(
  config => {
    // 白名单路径，不加 token
    const whiteList = ['/user/login', '/user/captcha']
    if (!whiteList.includes(config.url)) {
      const loginType = sessionStorage.getItem('currentLoginType')
      const token = loginType ? sessionStorage.getItem(`${loginType}_token`) : null
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
      } else {
        // 无 token 但访问非白名单接口，跳转登录
        router.push('/login')
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器：统一处理错误
httpService.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      const { status } = error.response
      if (status === 401) {
        ElMessage.error('登录已过期，请重新登录')
        // 清除登录状态
        const loginType = sessionStorage.getItem('currentLoginType')
        if (loginType) {
          sessionStorage.removeItem(`${loginType}_token`)
          sessionStorage.removeItem(`${loginType}_currentUser`)
          sessionStorage.removeItem(`${loginType}_menuList`)
          sessionStorage.removeItem(`${loginType}_refresh_token`)
        }
        sessionStorage.removeItem('currentLoginType')
        router.push('/login')
      } else if (status === 403) {
        ElMessage.error('无权限访问')
      } else {
        ElMessage.error(error.response?.data?.message || '请求失败')
      }
    }
    return Promise.reject(error)
  }
)

/* 网络请求方法封装 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url,
      method: 'get',
      params
    })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

// export function post(url, params = {}) {
//   return new Promise((resolve, reject) => {
//     httpService({
//       url,
//       method: 'post',
//       data: params
//     })
//       .then(response => {
//         console.log(response)
//         resolve(response)
//       })
//       .catch(error => {
//         console.log(error)
//         reject(error)
//       })
//   })
// }

export function post(url, params = {}, config = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url,
      method: 'post',
      data: params,
      ...config  // ✅ 合并额外配置，如 responseType, headers 等
    })
      .then(response => {
        console.log(response)
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })
}

export function del(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url,
      method: 'delete',
      data: params
    })
      .then(response => {
        console.log(response)
        resolve(response)
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })
}

export function fileUpload(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url,
      method: 'post',
      data: params,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function getServerUrl() {
  return baseUrl
}

export default {
  get,
  post,
  del,
  fileUpload,
  getServerUrl
}